import { all_roles } from '@/utils';
import { CommercialOffers } from '@/modules/commercial-offers/types';

const access_roles = {
  [CommercialOffers.Pages.COMMERCIAL_OFFERS]: all_roles,
  [CommercialOffers.Pages.OFFER_DETAIL]: all_roles,
};

export default access_roles;
